import React from 'react';
import { motion } from 'framer-motion';
import Card from './Card';
import Badge from './Badge';

interface SkillsProps {
  skills: {
    [key: string]: string[];
  };
}

const categoryLabels: Record<string, string> = {
  frontend: 'FRONTEND',
  backend: 'BACKEND',
  other: 'OTHER',
  alsoFamiliar: 'ALSO FAMILIAR',
};

const Skills: React.FC<SkillsProps> = ({ skills }) => {
  const coreCategories = ['frontend', 'backend', 'other'];
  const core = coreCategories.filter((c) => skills[c]?.length);
  const extra = skills.alsoFamiliar ?? [];

  return (
    <Card title="Skills" index={3}>
      <div className="space-y-8">
        {core.map((category, idx) => (
          <motion.div
            key={category}
            initial={{ opacity: 0, y: 6 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-40px' }}
            transition={{ duration: 0.3, delay: idx * 0.04, ease: [0.22, 1, 0.36, 1] }}
            className="grid grid-cols-1 sm:grid-cols-[140px_1fr] gap-3 sm:gap-6"
          >
            <h3 className="font-mono text-[11px] tracking-[0.18em] text-neutral-500 dark:text-neutral-500 pt-1.5">
              [{categoryLabels[category] ?? category.toUpperCase()}]
            </h3>
            <div className="flex flex-wrap gap-2">
              {skills[category].map((skill, i) => (
                <Badge key={i}>{skill}</Badge>
              ))}
            </div>
          </motion.div>
        ))}

        {extra.length > 0 && (
          <motion.div
            initial={{ opacity: 0, y: 6 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-40px' }}
            transition={{ duration: 0.3, delay: core.length * 0.04, ease: [0.22, 1, 0.36, 1] }}
            className="grid grid-cols-1 sm:grid-cols-[140px_1fr] gap-3 sm:gap-6 pt-4 border-t border-neutral-200 dark:border-neutral-800"
          >
            <h3 className="font-mono text-[11px] tracking-[0.18em] text-neutral-400 dark:text-neutral-600 pt-3">
              [{categoryLabels.alsoFamiliar}]
            </h3>
            <div className="flex flex-wrap gap-1.5 pt-2.5">
              {extra.map((skill, i) => (
                <Badge key={i} variant="subtle">{skill}</Badge>
              ))}
            </div>
          </motion.div>
        )}
      </div>
    </Card>
  );
};

export default Skills;
